import { API } from '..';

// Cài đặt / xác minh Authenticator (TOTP) cho admin — step-up bảo mật thao tác nhạy cảm (duyệt rút…).
// Endpoint identity-service, route admin qua gateway (Role Admin/Mod, tiêm auid từ token).
const BASE = '/v1/identity-service/accounts/cms';

export interface EnrollAuthenticatorResponse {
  sharedKey: string;
  otpauthUri: string;
}

export interface VerifyAuthenticatorResponse {
  valid: boolean;
  recoveryCodes?: string[] | null;
}

export const enrollAuthenticator = () =>
  API.post<EnrollAuthenticatorResponse>(`${BASE}/enroll-authenticator`).then((r) => r.data);

export const verifyAuthenticator = (code: string) =>
  API.post<VerifyAuthenticatorResponse>(`${BASE}/verify-authenticator`, { code }).then((r) => r.data);

// Admin đang đăng nhập đã bật Authenticator chưa — để trang bảo mật hiện "đã cài" thay vì bắt cài lại.
export const getAuthenticatorStatus = () =>
  API.get<{ enrolled: boolean }>(`${BASE}/authenticator-status`).then((r) => r.data);
